import { TFunction } from 'i18next';

export const translateCostClass = (t: TFunction, cc: string | null | undefined): string => {
  const map: Record<string, string> = {
    'Ordinary':          t('cat.costClasses.ordinary'),
    'Increased':         t('cat.costClasses.increased'),
    'Increased Kitten':  t('cat.costClasses.increasedKitten'),
    'Increased Sickroom':t('cat.costClasses.increasedSickroom'),
    'Other':             t('cat.costClasses.other'),
  };
  const key = cc || 'Ordinary';
  return map[key] || key;
};

export const translateStatus = (t: TFunction, status: string): string => {
  const map: Record<string, string> = {
    'Active':   t('catStatus.active'),
    'Deceased': t('catStatus.deceased'),
    'Adopted':  t('catStatus.adopted'),
    'Freed':    t('catStatus.freed'),
  };
  return map[status] || status;
};
